function DataReceiveCountStore()
{
    // //////// private members
    var counterCache = {
        'TOTAL' : 0
    };

    // //////// public members
    this.isBeingTracked = function(dataStreamId)
    {
        return counterCache.hasOwnProperty(dataStreamId);
    }

    this.incrementCount = function(dataStreamId)
    {
        counterCache[dataStreamId] = ++counterCache[dataStreamId];
        if (dataStreamId !== 'DATA.RECEIVE.COUNT')
        {
            counterCache['TOTAL'] = ++counterCache['TOTAL'];
        }
    }

    this.startTracking = function(dataStreamId)
    {
        counterCache[dataStreamId] = 0;
    }

    this.stopTracking = function(dataStreamId)
    {
        delete counterCache[dataStreamId];
    }

    this.getCountAndReset = function(dataStreamId)
    {
        var currentCount = counterCache[dataStreamId];
        counterCache[dataStreamId] = 0;
        return currentCount;
    }

    this.resetTotal = function()
    {
        counterCache['TOTAL'] = 0;
    }

    this.getAllTrackingDataStreamIds = function()
    {
        var dataStreams = [];
        for (var dataStreamId in counterCache)
        {
            dataStreams.push(dataStreamId);
        }
        return dataStreams;
    }

    this.isNotTrackingAny = function()
    {
        var count = 0;
        for (var property in counterCache)
        {
            ++count;
        }

        if (count == 1 && counterCache.hasOwnProperty('TOTAL'))
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    this.reset = function()
    {
        counterCache = {
            'TOTAL' : 0
        };
    }
}

module.exports = new DataReceiveCountStore();


// WEBPACK FOOTER //
// ./src-client-lib/data-receive-count/data-receive-count-store.js